import axios from "../../api/axios";

// Base URL from environment variable
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

const BillingService = {
  /**
   * Start free trial subscription for current user
   */
  startFreeTrial: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/start-free-trial`);
      // console.log("Free trial started successfully", response.data);
      
      // Standardize the response format by adding a success property
      // This ensures consistency with what the UI expects
      return {
        success: response.status >= 200 && response.status < 300,
        ...response.data
      };
      
    } catch (error) {
      console.error("Failed to start free trial", error);
      throw error; // Rethrow the error so mutation can handle it
    }
  },

  /**
   * List all available plans (used by useGetPlans hook)
   */
  listPlans: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/list-plans`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch subscription plans", error);
      throw error; // Rethrow the error
    }
  },

  /**
   * Get current user's subscription status
   */
  getSubscriptionStatus: async () => {
    try {
      const response = await axios.get(`${BASE_URL}/subscription/status`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch subscription status", error);
      throw error; // Rethrow the error
    }
  },



  /**
   * Cancel current subscription
   */
  cancelSubscription: async () => {
    try {
      const response = await axios.post(`${BASE_URL}/cancel-subscription`);
      
      // Standardize the response format by adding a success property
      return {
        success: response.status >= 200 && response.status < 300,
        ...response.data
      };
      
    } catch (error) {
      console.error("Failed to cancel subscription", error);
      throw error; // Rethrow the error
    }
  },

  /**
   * Create a new subscription for the current user
   * @param {Object} params - Subscription parameters
   * @param {number} params.plan_id - The ID of the plan to subscribe to
   * @param {boolean} params.has_plus - Whether the user wants the plus feature
   * @param {string} params.client_phone - The user's phone number
   * @param {string} params.passcode - The user's payment passcode
   * @param {string} params.language - The language for response messages
   * @returns {Promise<Object>} The API response
   */
  createSubscription: async ({ plan_id, has_plus, client_phone, passcode, language = 'FR' }) => {
    try {
      const response = await axios.post(`${BASE_URL}/create-subscription`, {
        plan_id,
        has_plus,
        client_phone,
        passcode,
        language,
      });
      
      // The backend now returns a standardized response with success property
      // No need to manually add success property as it's already in the response
      return response.data;
    } catch (error) {
      // Log the error for debugging but don't transform it
      console.error("Failed to create subscription", error);
      
      // Rethrow the original error so the mutation can handle it
      throw error;
    }
  }
};

export default BillingService;